<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-9 col-sm float-left">
            <h1 class="page-title">Hair Removal</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-3 mt-3">
                    <div class="col-sm-3 mt-1"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" />
                    </div>

                    <div class="col-sm-3 mt-1">
                        <mat-select placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')"
                            multiple>
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-1" *ngIf="role=='1' || role=='3'">
                        <mat-select placeholder="Lead Owner" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple
                            #itemSelect="ngModel">
                            <input class="mySearchInput" #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-1" *ngIf="role=='1' || role=='3'">
                        <mat-select placeholder="Booking Owner" [(ngModel)]="created_by" (click)="setSearchValue('bds')"
                            multiple #itemSelect="ngModel">
                            <input class="mySearchInput" #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-5">
                        <mat-select placeholder="Body Parts" [(ngModel)]="body_part" multiple>
                            <mat-option value="1">Underarms</mat-option>
                            <mat-option value="2">Face</mat-option>
                            <mat-option value="3">Chin</mat-option>
                            <mat-option value="4">Upper Lips</mat-option>
                            <mat-option value="5">Sidelocks</mat-option>
                            <mat-option value="6">Arms</mat-option>
                            <mat-option value="7">Legs</mat-option>
                            <mat-option value="8">Bikini</mat-option>
                            <mat-option value="9">Full Body</mat-option>
                            <mat-option value="10">Chest</mat-option>
                            <mat-option value="11">Stomach</mat-option>
                            <mat-option value="12">Back</mat-option>
                            <mat-option value="13">Combo</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Booking date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>

                    <div class="col-sm-3 mt-5">
                        <button type="button" class="btn btn-primary ml-2 mb-4"
                            (click)="loadHairRemovalData(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i>
                            Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadHairRemovalData(0,perpage)"><i class="fa fa-sync"
                            [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Appointment Id</th>
                            <th>Glamyo Patient Id</th>
                            <th>Glamyo Appointment Id</th>
                            <th>TREATMENT</th>
                            <th>BODY PART</th>
                            <th>Package</th>
                            <th class="tablefixcoloumn">PATIENT NAME</th>
                            <th>PATIENT AGE</th>
                            <th>GENDER</th>
                            <th>ADDRESS</th>
                            <th *ngIf="role!='6'">PATIENT MOBILE</th>
                            <th>LEAD LOCATION</th>
                            <th>CIRCLE</th>
                            <th>THERAPISTS NAME</th>
                            <th>LEAD OWNER</th>
                            <th>BOOKING DATE</th>
                            <th>BOOKING OWNER</th>
                            <th>DOCUMENTS</th>
                            <th>Remarks</th>
                            <th>Payment Details</th>
                            <th *ngIf="role=='1' || role=='2' || role=='3'">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let hairRemovals of hairRemovalList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{hairRemovals.patient_id}}</td>
                            <td>{{hairRemovals.glamyo_patient_id}}</td>
                            <td>GHHARE{{hairRemovals.id}}</td>
                            <td>{{hairRemovals.treatment_name}}</td>
                            <td><span class='badge badge-success'>{{hairRemovals.body_part}}</span></td>
                            <td><span class='badge badge-info'>{{hairRemovals.session}}</span></td>
                            <td class="tablefixcoloumn">{{hairRemovals.patient_name}}</td>
                            <td>{{hairRemovals.patient_age}}</td>
                            <td>{{hairRemovals.gender}}</td>
                            <td>
                                <div style="width: 250px;">{{hairRemovals.address}}</div>
                            </td>
                            <td *ngIf="role!='6'">{{hairRemovals.patient_mobile}}</td>
                            <td>{{hairRemovals.city_name}}</td>
                            <td>{{hairRemovals.circle_name}}</td>
                            <td>
                                <div style="width: 150px;">{{hairRemovals.doctor_name}}</div>
                            </td>
                            <td>{{hairRemovals.bd_name}}</td>
                            <td>{{hairRemovals.booking_date*1000|date:'d MMM, yyyy'}}</td>
                            <td>{{hairRemovals.hair_removal_booking_owner}}</td>
                            <td>
                                <div *ngIf="hairRemovals.consent_form_copy.length > 0; else noCopy">
                                    <span *ngFor="let aDlink of hairRemovals.consent_form_copy"><a
                                            href="{{sc3Url+aDlink.consent_form}}" target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noCopy>
                                    Not uploaded
                                </ng-template>
                            </td>
                            <td>
                                <div style="width: 250px;">{{hairRemovals.remarks}}</div>
                            </td>
                            <td>
                                <div class="prodetail" *ngIf="hairRemovals.hair_removal_details">
                                    <span
                                        *ngFor="let paymentDetails of hairRemovals.hair_removal_details;let i = index;">
                                        <span> {{paymentDetails.payment_mode}} <span>=</span>
                                            {{paymentDetails.received_amount}} </span><br>
                                    </span>
                                </div>
                            </td>

                            <td *ngIf="role=='1' || role=='2' || role=='3'">
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="{{hairRemovals.lead_id}}"
                                        style="height: 100px; overflow: scroll;">
                                        <a class="dropdown-item" (click)="sharePaymentLink(hairRemovals.lead_id,6)"><i class="fa fa-credit-card"></i>Share Payment Link</a>
                                        <a class="dropdown-item"
                                            (click)="updateHairRemovalDetails(hairRemovals.lead_id)"><i
                                                class="fa fa-pen"></i> Update Details
                                        </a>
                                        <a class="dropdown-item" (click)="viewHairRemovalDetails(hairRemovals.id)"><i class="fa fa-comments"></i> Share Details</a>
                                        <a *ngIf="role=='1'" class="dropdown-item"
                                            (click)="openHistoryPopup(hairRemovals.id)"><i class="fa fa-eye"></i>
                                            History
                                        </a>
                                    </div>
                                </div>
                            </td>

                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !hairRemovalList.length">
                            <td colspan="20"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>


<!-- The Modal to view Hair Removal history -->
<div class="modal fade" id="myHistoryModal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">History</h4>
                <button type="button" class="close" (click)="closeHistoryPopup()"></button>
            </div>
            <div class="modal-body history_modal">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                    <tbody>
                        <tr *ngFor="let updatedLog of updatedLodData">
                            <td class="no-padding-bottom">
                                <div class="small_text" [innerHTML]="updatedLog.message | safe:'html'"></div>
                                <div class="small text-muted small_text_creation">
                                    <i class="fas fa-clock"></i> {{updatedLog.created_at*1000|date:'dMMM, yyyy h:mm'
                                    }}
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="!updatedLodData.length && history_loaded">
                            <td>No history found</td>
                        </tr>
                        <tr *ngIf="history_loading">
                            <td><i class="fa fa-spin fa-spinner"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn" (click)="closeHistoryPopup()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- The Modal to view Hair Removal -->
<div class="modal fade" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Laser Hair Removal Schedule</h4>
          <button type="button" class="close" (click)="hideModal('1')"></button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body"id="pdfTable" #pdfTable>
          <div><h3><span style="color:#0f74b2">Glamyo</span>&nbsp;<span style="color:#69bb45">Health</span></h3></div>
          <table>
            <tr>
            <th colspan="2" style="color:red">**Note: Avoid Using soap or any cosmetic creame before the treatment.</th>
            </tr>
            <tr>
                <th colspan="2">Booking Details</th>
            </tr>
            <tr>
                <td><strong>Booking Id -</strong></td>
                <td> GHHARE{{hairRemovalUserDetail.id}}</td>
            </tr>
            <tr>
                <td><strong>Patient Name -</strong></td>
                <td>{{hairRemovalUserDetail.patient_name}}</td>
            </tr>
            <tr>
                <td><strong>Coordinator -</strong></td>
                <td>{{hairRemovalUserDetail.hair_removal_booking_owner}}</td>
            </tr>
            <tr>
                <td><strong>Therapist Name -</strong></td>
                <td>{{hairRemovalUserDetail.doctor_name}}</td>
            </tr>
            <tr>
                <td><strong>Treatment -</strong></td>
                <td>{{hairRemovalUserDetail.treatment_name}} - {{hairRemovalUserDetail.session}} </td>
            </tr>
            <tr>
                <td><strong>Address -</strong></td>
                <td>{{hairRemovalUserDetail.address}}</td>
            </tr>
            <tr>
                <td><strong>Treatment Date -</strong></td>
                <td>{{hairRemovalUserDetail.booking_date*1000 | date:'dd MMM, yyyy'}}</td>
            </tr>
            <tr>
                <td><strong>Treatment Time -</strong></td>
                <td>{{hairRemovalUserDetail.time_slots}}</td>
            </tr>
            <tr>
                <td><strong>Payment -</strong></td>
                <td *ngIf="hairRemovalUserDetail.hair_removal_details">
                <div class="" *ngIf="hairRemovalUserDetail.hair_removal_details">
                    <span *ngFor="let hairRemovalUserDetails of hairRemovalUserDetail.hair_removal_details;let i = index;">
                        <span> {{hairRemovalUserDetails.payment_mode}} <span>=</span> {{hairRemovalUserDetails.received_amount}} </span><br>
                    </span>
                </div>
                </td>
            </tr>
          </table>
        </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button class="btn btn-primary" (click)="downloadAsPDF()">Share</button>
          <button type="button" class="btn" (click)="hideModal('1')">Close</button>
        </div>
      </div>
    </div>
</div>